export default __webpack_public_path__ + "static/media/stefann.87ace6bb.jpg";